import { RouteView } from '@/layouts';

const templateRouter = {
  path: '/note',
  name: 'Note',
  redirect: '/note/template',
  component: RouteView,
  meta: {
    title: '短信发送',
    icon: 'icontemplate',
    roles: ['admin'],
  },
  children: [
    {
      path: 'template',
      name: 'NoteTemplate',
      component: RouteView,
      redirect: '/note/template/list',
      meta: {
        title: '短信模板',
        icon: 'icon-navicon-dxmbgl',
        roles: ['admin'],
      },
      hideChildrenInMenu: true,
      children: [
        {
          path: 'list',
          name: 'templateList',
          component: () => import('@/views/template/List'),
          meta: {
            title: '模板管理列表',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
    {
      path: 'record',
      name: 'NoteRecord',
      component: RouteView,
      redirect: '/note/record/list',
      meta: {
        title: '短信发送记录',
        icon: 'icon-duanxinjilu',
        roles: ['admin'],
      },
      hideChildrenInMenu: true,
      children: [
        {
          path: 'list',
          name: 'recordList',
          component: () => import('@/views/template/RecordList'),
          meta: {
            title: '',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    }],

};

export default templateRouter;
